module.exports = __webpack_public_path__ + "img/apple-pay.6548b7ad.png";